import Link, { createLinkObject } from '@client/core/PageSwitch/Link';
import { TextStyle } from '@client/style/TextStyles';
import React, { useCallback } from 'react';
import styled from 'styled-components';
import infoIcon from '@client/assets/svgs/icon-info.svg';
import { DateUtils } from '@client/core/utils/DateUtils';
import SpilleplanEvent from './SpillleplanEvent';
import DateIndicator from './DateIndicator';

const LocationEntry = styled.div<{ $index: number; $hours: number }>`
	grid-column: 1;
	grid-row: ${props => props.$index + 2};

	display: grid;
	grid-template-columns: repeat(${props => Math.ceil(props.$hours * 4)}, 1fr);
	grid-template-rows: max-content;
	align-content: start;

	border-bottom: 1px solid currentColor;
	position: relative;
	padding: 20px 0;
	padding-left: var(--gridMargin);
`;

const LocationName = styled.p`
	grid-column: 1 / -1;
	${TextStyle.family('title')}
	${TextStyle.weight('bold')}
	${TextStyle.size('medium')}
	line-height: 1.2;
	position: sticky;
	display: flex;
	top: 0;
	left: var(--gridMargin);
	padding-right: var(--gridMargin);
	padding-bottom: 20px;
	width: fit-content;
	height: fit-content;
	text-transform: capitalize;

	svg {
		margin-left: 5px;
	}
`;

const InfoIcon = styled(infoIcon)``;

export default function LocationRow({
	events,
	location,
	dayStartTime,
	hours,
	index,
}: {
	events: any[];
	location: string;
	dayStartTime: Date;
	hours: number;
	index: number;
}) {
	const getRelativeStart = useCallback(
		(eventStart: string) => {
			return DateUtils.getHoursBetween(new Date(eventStart), dayStartTime);
		},
		[dayStartTime]
	);

	const getDuration = useCallback(
		(eventStart: string, i: number) => {
			const nextEventStart = events[i + 1]?.startTime;
			if (!nextEventStart) return hours - getRelativeStart(eventStart);
			return DateUtils.getHoursBetween(new Date(eventStart), new Date(nextEventStart));
		},
		[events, hours, getRelativeStart]
	);

	return (
		<LocationEntry $hours={hours} $index={index}>
			<DateIndicator earliestTime={dayStartTime} />

			<LocationName>
				{events[0].location.link ? (
					<Link data={createLinkObject(events[0].location.link)}>
						{location}
						<InfoIcon></InfoIcon>
					</Link>
				) : (
					location
				)}
			</LocationName>

			{events
				.sort((a, b) => Date.parse(a.startTime) - Date.parse(b.startTime))
				.map((item, i) => (
					<SpilleplanEvent
						key={item.id}
						data={item}
						start={getRelativeStart(item.startTime)}
						duration={getDuration(item.startTime, i)}
					/>
				))}
		</LocationEntry>
	);
}
